module.exports = __webpack_public_path__ + "static/media/reactnative.6a4da18e.png";